import {
    MenuType,
    useCheckLogin,
    useOwnTeam,
    usePageState,
} from "@hg/recall-frame"
import cls from "classnames"
import React, { FC, useEffect, useMemo, useRef, useState } from "react"

import { sfx } from "@/assets/audios/sfx"
import OutlinedText from "@/components/OutlinedText"
import { i18n, RecallTextPath } from "@/i18n"
import { collect } from "@/utils/sdk"
import { useRoleInfo } from "@/user/session"
import { titleMap } from "../menu"

import styles from "./index.module.scss"

export const MenuBtn: FC<{ onClick: () => void; mid: string }> = ({
    onClick,
    mid,
}) => {
    const role = useRoleInfo()
    const checkLogin = useCheckLogin("HG")
    const teamSwr = useOwnTeam()

    const { activeMenu } = usePageState()

    const active = useMemo(() => {
        return activeMenu === mid
    }, [activeMenu, mid])

    const title = useMemo(() => {
        const key = titleMap[mid as keyof typeof titleMap]
        // return key ? t(key) : "-"
        return key ? i18n.getRecall(key as RecallTextPath) : "-"
    }, [mid])

    const clickHandler = () => {
        sfx.play("click")
        if (mid === "progress" || mid === "record") {
            const res = checkLogin()
            if (!res) {
                return
            }
        }
        if (teamSwr.data?.memberUid) {
            // 埋点
            // collect("click", {
            //     target: "progress_check",
            // })
        }
        onClick()
    }

    return (
        <>
            <div
                key={mid}
                className={cls(styles.menuBtn, active ? styles.active : null)}
                onClick={clickHandler}
            >
                <div className={styles.defaultBg}></div>
                <div className={styles.bg}></div>
                <div
                    className={cls(styles.inner, active && styles.innerActive)}
                >
                    <div className={styles.wrap}>
                        <Icon mid={mid} active={active} />
                        <OutlinedText
                            className={styles.text}
                            text={title}
                            fontSize={30}
                            strokeWidth={6}
                            fillColor={active ? "#8E7354" : "#ffffff"}
                            strokeColor={active ? "#ffffff" : "#1a5b5e"}
                            fontFamily="SourceHanSansJP-VF"
                        />
                    </div>
                </div>
            </div>
            <img
                className={styles.split}
                src={require("@/assets/imgs/recall/split.png")}
                alt="split"
            ></img>
        </>
    )
}

const Icon: FC<{ mid: string; active: boolean }> = ({ mid, active }) => {
    return (
        <div
            className={cls(
                styles.icon,
                styles[mid],
                active ? styles.active : null
            )}
        ></div>
    )
}
